var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.filaClass},[_c('label',{class:_vm.ui.colLeftClass},[_vm._t("label",function(){return [_vm._v(_vm._s(_vm.label))]}),(_vm.ayuda)?_c('div',{staticClass:"text-muted font-size-sm mt-1"},[_vm._v(_vm._s(_vm.ayuda))]):_vm._e()],2),_c('div',{class:_vm.ui.colRightClass},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }